import NextLink from 'next/link';

import { Container, Link, SectionText } from '@/atoms';
import { SwiperCustom } from '@/molecules';
import HousingCard from '@/organisms/housing-card';

import type { TypeHousingCardProps } from '@/organisms/housing-card';
import type { FunctionComponent } from 'react';
import type { TypeHousingProps } from './types';

/**
 * housing
 */
export const Housing: FunctionComponent<TypeHousingProps> = ({
  className = '',
  backgroundColorBottom,
  backgroundColorBottomMobile,
  backgroundColorTop,
  backgroundColorTopMobile,
  caption,
  cutLevel = 50,
  cutLevelMobile = 50,
  description,
  housingCardProps,
  link,
  title,
  textColor,
  index,
  id,
}: TypeHousingProps) => (
  <Container
    index={index}
    id={id}
    backgroundColorBottom={backgroundColorBottom}
    cutLevel={cutLevel === null ? 50 : cutLevel}
    cutLevelMobile={cutLevelMobile === null ? 50 : cutLevel}
    backgroundColorTop={backgroundColorTop}
    backgroundColorBottomMobile={backgroundColorBottomMobile}
    backgroundColorTopMobile={backgroundColorTopMobile}
    className={`flex flex-col gap-8 ${className}`}
  >
    <SectionText
      direction="row"
      title={title}
      caption={caption}
      desc={description}
      variant={textColor}
      textAlign="start"
    />

    <div className="-mx-5 md:ml-0">
      <SwiperCustom
        gap={20}
        navigation
        scrollbar
        slidesPerView={3}
        slidesPerViewMobile={1.2}
      >
        {housingCardProps?.map((house: TypeHousingCardProps, index: number) => (
          <HousingCard
            key={index}
            {...house}
            className={`h-full ${house?.className ?? ''} md:ml-0 ${
              index === 0 ? 'ml-5' : ''
            } ${index === housingCardProps.length - 1 ? 'mr-5' : ''}`}
          />
        ))}
      </SwiperCustom>
    </div>

    <>
      {link?.src && link?.label && (
        <NextLink passHref prefetch={false} href={link.src}>
          <Link className="self-center md:self-end" arrow variant={textColor}>
            {link.label}
          </Link>
        </NextLink>
      )}
    </>
  </Container>
);

Housing.displayName = 'Housing';
